















import { Component, Mixins, Inject, Ref } from 'vue-property-decorator';
import { AxTransparent } from '@/mixins';
import * as I from '@/interfaces';
import AxListPanel from './AxListPanel.vue';
import { AxStorage } from '@/storage';

export interface AxZonePanelParams {
  attrs: {
    panelTitle: string;
    itemList: string[];
  };

  listeners: {
    group: (zoneName: string, zoneCode: number, group: number) => void;
    item: (zoneName: string, zoneCode: number, group: number, idx: number) => void;
    add: () => void;
    search: (text: string) => void;
  };
}

@Component
export default class AxZonePanel extends Mixins(AxTransparent) {
  @Ref()
  panel!: AxListPanel;

  @Inject()
  getLoginData!: () => I.Account;

  getZoneInfo(group: number) {
    return this.getLoginData().listZone.find((_, i) => i === group);
  }

  get listPanel() {
    return {
      attrs: {
        ...this.attrs,
        groupHint: '구역 : ',
        groupList: this.zoneList,
        defaultGroup: this.defaultGroup
      },
      listeners: {
        group: async (group: number) => {
          const currentZone = this.getZoneInfo(group);
          if (currentZone) {
            AxStorage.axZone = group;
            this.$emit('group', currentZone.name, currentZone.code, group);
          }
        },
        item: (group: number, idx: number) => {
          const currentZone = this.getZoneInfo(group);
          if (currentZone) {
            this.$emit('item', currentZone.name, currentZone.code, group, idx);
          }
        },
        add: () => {
          this.$emit('add');
        },
        search: (text: string) => {
          this.$emit('search', text);
        }
      }
    };
  }

  get zoneList() {
    return this.getLoginData().listZone.map(x => x.name);
  }

  get defaultGroup() {
    const group = AxStorage.axZone;
    if (group >= this.zoneList.length) return 0;
    return group;
  }
}
